export default __webpack_public_path__ + "static/platform-fe9461df52b3bb57cd0be11a15ab8c25.png";